<template>
  <div class="admin_accounts">
    <adminAccountsList ref="list"></adminAccountsList>
    <router-view @list-reload="listReload" />
  </div>
</template>

<script>
import adminAccountsList from './adminAccountsList.vue'

export default {
  components: {
    adminAccountsList
  },
  methods: {
    async listReload() {
      await this.$refs.list.reload()
    }
  }
}
</script>
<style scoped>
.admin_accounts {
  height: 100%;
  overflow-wrap: anywhere;
}
</style>



// WEBPACK FOOTER //
// src/components/adminAccounts/adminAccounts.vue